import styled from "styled-components"

export const NavBar = styled.div`
  transition: 0.3s;

  .scroll {
    display: inherit;
    backdrop-filter: saturate(180%) blur(20px);
    background-color: rgba(255, 255, 255, 0.72);
    border-bottom: 1px solid #e1e4e7;

    .scroll-mar {
      margin: 1px 0 5px 0;
      transition: 0.3s;
    }

    .item-content {
      a {
        color: var(--black);

        @media (max-width: 992px) {
          color: var(--white);
        }
      }
    }

    .logo {
      margin-top: 4px;
    }
  }
`

export const NavWrapper = styled.nav`
  width: 100%;
  position: fixed;
  z-index: 10000;
`

export const NavContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 10px 0;

  @media (max-width: 992px) {
    margin: 10px 0 10px 7px;
  }
`
